import { useEffect, useState } from 'react'

import { Box, Slide, Snackbar, Typography } from '@mui/material'
import { toastsIndicated, useAppDispatch, useAppSelector } from 'store'

const toastDuration = 5000
const transitionDuration = 100

const TRIGGERED = 1
const ENDED = 2

function SlideTransition(props: any) {
  return <Slide {...props} direction='up' timeout={transitionDuration} />
}

type Toast = {
  id: number
  message: string
  status: number
}

function ToastContainer() {
  const toastState = useAppSelector((state) => state.toast)
  const dispatch = useAppDispatch()
  const [toasts, setToasts] = useState([] as Toast[])

  useEffect(() => {
    if (toastState.toasts.length === 0) {
      return
    }
    const toastsReady = toastState.toasts.map((toast) => {
      return {
        id: toast.id,
        message: toast.message,
        status: TRIGGERED
      } as Toast
    })
    dispatch(toastsIndicated(toastState.toasts.map((t) => t.id)))
    setToasts([...toasts, ...toastsReady])
  }, [toastState])

  useEffect(() => {
    if (toasts.length === 0) {
      return
    }
    const clearToasts = setTimeout(() => {
      setToasts(toasts.filter((toast) => toast.status !== ENDED))
    }, toastDuration + transitionDuration)
    return () => clearTimeout(clearToasts)
  }, [toasts])

  function handleClose(index) {
    const next = toasts.map((t, i) => {
      if (i === index) {
        return {
          id: t.id,
          message: t.message,
          status: ENDED
        }
      } else {
        return t
      }
    })
    setToasts(next)
  }

  return (
    <Box>
      {toasts.map((toast, index) => {
        return (
          <Snackbar
            key={toast.id}
            open={toast.status === TRIGGERED}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            autoHideDuration={toastDuration}
            TransitionComponent={SlideTransition}
            onClose={(event: React.SyntheticEvent | Event, reason?: string) => {
              if (reason === 'clickaway') {
                return
              }
              handleClose(index)
            }}
            aria-live='polite'
          >
            <Box
              sx={{
                backgroundColor: 'gray.1',
                borderRadius: '26px',
                padding: { xs: '16px 29.5px 16px', md: '17px 29.5px 16px' },
                minHeight: '52px',
                minWidth: '312px'
              }}
            >
              <Typography
                sx={{
                  textAlign: 'center',
                  fontSize: '16px',
                  lineHeight: '19px',
                  color: 'primary.contrastText',
                  fontWeight: '500'
                }}
              >
                {toast.message}
              </Typography>
            </Box>
          </Snackbar>
        )
      })}
    </Box>
  )
}

export default ToastContainer
